import bg from '../assets/bg.png';
import chef from '../assets/chef.jpg';
import CM from '../assets/CM.png';
import gallery01 from '../assets/gallery01.jpg';
import gallery02 from '../assets/gallery02.jpg';
import gallery03 from '../assets/gallery03.jpg';
import gallery04 from '../assets/gallery04.jpg';
import gallery05 from '../assets/gallery05.jpg';
import shake from '../assets/shake.jpg';
import logo from '../assets/logo.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.jpg';
import findus from '../assets/findus.jpg';
import laurels from '../assets/laurels.jpg';
import award01 from '../assets/award01.png';
import award02 from '../assets/award02.png';
import award03 from '../assets/award03.png';
import award05 from '../assets/award05.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import mocho from '../assets/mocho.png';

export default {
  bg,
  chef,
  CM,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  shake,
  logo,
  menu,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  mocho,
};
